import type { ReactNode } from 'react';
import type { LinkProps } from '@tanstack/react-router';
import { Page } from '@evogard/ui';
import { NotFoundContent } from './NotFoundContent.js';

const DEFAULT_HINT =
  'Confira o código. Um registro de outra base não aparece aqui: se ele é de outra praça, troque a base no topo da tela.';

/**
 * O registro que não existe — a mesma tela do endereço que não existe
 * (`NotFoundScreen`), com o título dizendo o que faltou e a lista do assunto
 * como saída principal.
 *
 * A ficha devolve isto NO LUGAR dela quando a consulta lança `NotFoundError`
 * (o `404` da API), e não dentro da própria moldura: até 26/10/2026 cada ficha
 * desenhava o cartão debaixo do seu título ("Veículo", "Demanda"), e a resposta
 * para o mesmo fato tinha duas caras.
 */
export function MissingRecord({
  title,
  children,
  list,
}: {
  /** "Este veículo não existe no cadastro desta base" — dito como fato. */
  title: string;
  /** O porquê provável e o que fazer; sem ele, a frase padrão desta aplicação. */
  children?: ReactNode;
  /** A lista do assunto: onde se acha o registro certo. */
  list: { to: LinkProps['to']; search?: LinkProps['search']; label: string };
}) {
  return (
    <Page>
      <NotFoundContent title={title} hint={children ?? DEFAULT_HINT} primary={list} />
    </Page>
  );
}
